import changeVoiceTariff4GApi from '@/api/changeVoiceTariff4G/changeVoiceTariff4GApi.js'
import moment from 'moment';

export default {
	name: 'change-voice-tariff-4G',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			ftGetVoiceRateplan:{getVoiceRateplan:{}},
			rateplanId:null,
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		this.getVoiceRateplan();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async getVoiceRateplan(){
			this.ftGetVoiceRateplan = await changeVoiceTariff4GApi.getVoiceRateplan();
		},
		async changeRatePlan(){
			const isValid = await this.$validator.validate();
			if(!isValid || !this.rateplanId || !this.ftGetVoiceRateplan.getVoiceRateplan.changeDate){
				$("#myModal").modal('show');
				return;
			}
			let changeDate = await changeVoiceTariff4GApi.changeVoiceRateplan(this.rateplanId, this.ftGetVoiceRateplan.getVoiceRateplan.changeDate);
			if(changeDate){
				let date = moment(changeDate, 'YYYYMMDD');
				changeDate = date._isValid ? '民國' + (date.format('YYYY') - 1911) + '年' + date.format('M') + '月' + date.format('D') + '日' : changeDate;
				this.$router.push({name:'change-voice-tariff-result-4G', params: {changeDate}});
			}
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/changeVoiceTariff4G/changeVoiceTariff4G.js